export const AWAY_TRIP_STATUS_REQUESTED = "requested";
export const AWAY_TRIP_STATUS_APPROVED = "approved";
export const AWAY_TRIP_STATUS_REJECTED = "rejected";
export const AWAY_TRIP_STATUS_IN_REVIEW = "in_review";
export const AWAY_TRIP_STATUS_REVIEW_SUCCESS = "review_success";
export const AWAY_TRIP_STATUS_REVIEW_REJECT = "review_reject";
export const AWAY_TRIP_STATUS_COMPLETED = "completed";

export const AWAY_TRIP_STATUSES = {
    [AWAY_TRIP_STATUS_REQUESTED]: "Da approvare",
    [AWAY_TRIP_STATUS_APPROVED]: "Approvata",
    [AWAY_TRIP_STATUS_REJECTED]: "Rifiutata",
    [AWAY_TRIP_STATUS_IN_REVIEW]: "Da revisionare",
    [AWAY_TRIP_STATUS_REVIEW_SUCCESS]: "Revisione approvata",
    [AWAY_TRIP_STATUS_REVIEW_REJECT]: "Revisione rifiutata",
    [AWAY_TRIP_STATUS_COMPLETED]: "Completata"
};

export const AWAY_TRIP_STATUS_BADGE_CLASSES = {
    [AWAY_TRIP_STATUS_REQUESTED]: "badge badge-warning",
    [AWAY_TRIP_STATUS_APPROVED]: "badge badge-success",
    [AWAY_TRIP_STATUS_REJECTED]: "badge badge-danger",
    [AWAY_TRIP_STATUS_IN_REVIEW]: "badge badge-info",
    [AWAY_TRIP_STATUS_REVIEW_SUCCESS]: "badge badge-success",
    [AWAY_TRIP_STATUS_REVIEW_REJECT]: "badge badge-danger",
    [AWAY_TRIP_STATUS_COMPLETED]: "badge badge-secondary"
};
